import * as React from 'react';
import * as Dialog from '@naan/primitives/modals/dialog';
import { observer } from 'mobx-react';
import __ from '@core/lib/localization';

export const MarkStoryCompleteDialog = observer(
  ({ onReset, onDismiss }: { onReset: () => void; onDismiss: () => void }) => {
    return (
      <Dialog.Container onDismiss={onDismiss} open={true}>
        <Dialog.Heading>
          {__('Mark story complete', 'story.markStoryComplete')}
        </Dialog.Heading>
        <Dialog.Body>
          {__(
            "This will mark all chapters as complete, but won't affect your progress statistics or vocab list.",
            'story.resetStoryDialogBody'
          )}
        </Dialog.Body>
        <Dialog.ButtonsContainer>
          <Dialog.Button
            onClick={onDismiss}
            label={__('Cancel', 'common.cancel')}
            presentation="grayTransparent"
          />
          <Dialog.Button
            onClick={onReset}
            label={__('Mark complete', 'common.markComplete')}
            presentation="teal"
          />
        </Dialog.ButtonsContainer>
      </Dialog.Container>
    );
  }
);
